export default __webpack_public_path__ + "static/media/completedIcon.31eddc05.svg";